import { propPanel as parentPropPanel } from '../text/propPanel';
import text from "../text";
export const propPanel = {
    ...text.propPanel,
    widgets: { ...parentPropPanel.widgets },
    schema: (propPanelProps) => {
        if (typeof parentPropPanel.schema !== 'function') {
            throw Error('Oops, is text schema no longer a function?');
        }
        return {
            ...parentPropPanel.schema(propPanelProps),
            '-------': { type: 'void', widget: 'Divider' },
            section: {
                title: propPanelProps.i18n('schemas.section'),
                type: 'string',
                widget: 'Input',
                span: 24,
                required: true,
            },
            appRender: {
                type: 'object',
                properties: {
                    label: {
                        title: propPanelProps.i18n('schemas.label'),
                        type: 'string',
                        widget: 'Input',
                        span: 24,
                    },
                    inputType: {
                        title: 'Type',
                        type: 'string',
                        widget: 'select',
                        props: {
                            options: [
                                { label: 'Text', value: 'text' },
                                { label: 'Number', value: 'number' },
                            ]
                        },
                        span: 24,
                    },
                }
            }
        };
    },
    defaultSchema: {
        ...text.propPanel.defaultSchema,
        type: 'TextInput',
        section: "",
        appRender: { label: "", inputType: "text", text: "" },
    },
};
//# sourceMappingURL=propPanel.js.map